export default {
    inquiryAndAttendance: 'คำร้องและการลงเวลา',
    inquiry: 'คำร้องขอ',
    statusAttendance: 'สถานะเข้างาน',
    manageAttendance: 'จัดการสถานะ',
    punchLog: 'บันทึกการเข้าออก',
    searchByEmployeeName: 'ค้นหาจากชื่อ, รหัสพนักงาน',
    search: 'ค้นหา',
    employeeId: 'รหัสพนักงาน',
    employeeName: 'ชื่อ - นามสกุล',
    bureau: 'สำนักงาน',
    position: 'ตำแหน่ง',
    submittedDate: 'วันส่งคำร้องขอ',
    date: 'วันที่',
    inquiryText: 'คำร้องขอ',
    status: 'สถานะ',
    action: '',
    congratulation: 'ยินดีด้วย',
    cannotEditTheApproval: 'ไม่สามารถแก้ไขคำขอที่อนุมัติแล้วได้',
    cannotEditTheRejected: 'ไม่สามารถแก้ไขคำขอที่ถูกยกเลิกแล้วได้'
}
